import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  CircularProgress,
  Card,
  CardContent
} from '@material-ui/core';
import { solicitudDetalleService } from '../../services';

const SeccionDDJJActividadOrigenFondos = ({ solicitudId }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    ddjjActividadOrigenFondos: ''
  });

  const cargarDatos = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await solicitudDetalleService.getDDJJActividadOrigenFondos(solicitudId);
      if (response) {
        setFormData({
          ddjjActividadOrigenFondos: response.ddjjActividadOrigenFondos || ''
        });
      }
    } catch (err) {
      setError('Error al cargar la declaración jurada');
    } finally {
      setLoading(false);
    }
  }, [solicitudId]);

  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  const handleInputChange = (value) => {
    setFormData({ ddjjActividadOrigenFondos: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const datosParaGuardar = {
        solicitudId: parseInt(solicitudId),
        ddjjActividadOrigenFondos: formData.ddjjActividadOrigenFondos
      };
      await solicitudDetalleService.saveDDJJActividadOrigenFondos(datosParaGuardar);
      setSuccess('Datos guardados exitosamente');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Error al guardar los datos');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Declaración Jurada de Origen y Licitud de fondos
        </Typography>
        {error && (
          <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        )}
        {success && (
          <Box p={2} mb={2} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px' }}>
            <Typography variant="body2">{success}</Typography>
          </Box>
        )}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Describa la actividad económica que originó los fondos"
                multiline
                rows={6}
                value={formData.ddjjActividadOrigenFondos}
                onChange={(e) => handleInputChange(e.target.value)}
                variant="outlined"
                placeholder="Ingrese la descripción de la actividad económica..."
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saving}
              >
                {saving ? <CircularProgress size={20} /> : 'Guardar'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default SeccionDDJJActividadOrigenFondos;
